var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ApiService } from '../../services/api.service';
import * as _ from 'lodash';
import { CALENDAR_LOCALE } from '../../services/constant';
import * as moment from 'moment';
import { HttpParams } from '@angular/common/http';
import { TemplateService } from '../../services/template.service';
var TaxB2PComponent = (function () {
    function TaxB2PComponent(apiService, template) {
        this.apiService = apiService;
        this.template = template;
        this.itemsPerPage = 40;
        this.detailItemsPerPage = 40;
        this.currentPage = 1;
        this.detailCurrentPage = 1;
        this.loading = false;
        this.tableColumn = [
            { field: 'date', header: 'Batch Date' },
            { field: 'buyer', header: 'ชื่อผู้ซื้อ' },
            { field: 'seller', header: 'ชื่อผู้ขาย' },
            { field: 'doc_count_success', header: 'เอกสารที่สำเร็จ' },
            { field: 'doc_count_fail', header: 'เอกสารที่ผิดพลาด' },
            { field: 'doc_count_all', header: 'รวม' },
        ];
        this.detailTableColumn = [
            { field: 'branch', header: 'สาขา' },
            { field: 'header_issue_date', header: 'วันที่ออกเอกสาร' },
            { field: 'invoice_number', header: 'เลขที่' },
            { field: 'doc_type', header: 'ประเภท' },
            { field: 'message', header: 'ผลลัพธ์' },
            { field: 'status', header: 'สถานะ' }
        ];
        this.documentType = [
            { label: 'ทั้งหมด', value: null }
        ];
        this.status = [
            { label: 'ทั้งหมด', value: null },
            { label: 'เฉพาะที่สำเร็จ', value: 'success_only' },
            { label: 'เฉพาะที่ผิดพลาด', value: 'failed_only' }
        ];
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.selectedBuyer = null;
        this.selectedCompany = null;
        this.selectedDocumentType = null;
        this.selectedStatus = null;
        this.selectedDetailDocumentType = null;
        this.selectedDetailStatus = null;
    }
    TaxB2PComponent.prototype.ngOnInit = function () {
        this.populateDropdown();
        this.loadData();
    };
    Object.defineProperty(TaxB2PComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaxB2PComponent.prototype, "dateRange", {
        get: function () {
            var start = moment(this.startDate).format('DD/MM/YYYY');
            var end = moment(this.endDate).format('DD/MM/YYYY');
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TaxB2PComponent.prototype, "viewingDateDisplay", {
        get: function () {
            if (this.viewing == null) {
                return null;
            }
            var date = parseInt(this.viewing.doc_date.substr(8, 2), 10);
            var month = this.calendarLocale.monthNames[parseInt(this.viewing.doc_date.substr(5, 2), 10) - 1];
            var year = parseInt(this.viewing.doc_date.substr(0, 4), 10) + 543;
            return date + ' ' + month + ' ' + year;
        },
        enumerable: true,
        configurable: true
    });
    TaxB2PComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    TaxB2PComponent.prototype.populateDropdown = function () {
        var _this = this;
        // populate company list
        this.company = [{
                label: 'ทั้งหมด',
                value: null
            }];
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        // populate supplier list
        this.supplier = [{
                label: 'ทั้งหมด',
                value: null
            }];
        this.apiService.getBuyer({ include_in_b2p: 'True' }).subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.supplier.push({
                    label: obj.name,
                    value: obj.id
                });
            });
        });
        // populate document type
        this.documentType = this.template.getDropdown();
        // set default date range
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
    };
    TaxB2PComponent.prototype.loadData = function (params) {
        var _this = this;
        this.loading = true;
        var data = {
            company: this.selectedCompany,
            buyer: this.selectedBuyer,
            doc_type: this.selectedDocumentType,
            start_date: moment(this.startDate).format('YYYY-MM-DD'),
            end_date: moment(this.endDate).format('YYYY-MM-DD'),
            status: this.selectedStatus,
            items_per_page: this.itemsPerPage
        };
        // apply sort if any
        if (this.sortBy != null && this.sortMode != null) {
            data['sort'] = this.sortBy;
            data['sort_type'] = this.sortMode;
        }
        // remove page number if current page is 1
        if (this.currentPage === 1) {
            params = null;
        }
        this.apiService.postB2PDocumentSummary(data, params).subscribe(function (result) {
            _this.totalItems = result.count;
            _this.tableData = result.results.map(function (obj) { return (__assign({}, obj, { loadingExcel: false })); });
            _this.loading = false;
        }, function (error) {
            _this.error = 'เกิดข้อผิดพลาด';
            _this.loading = false;
        });
    };
    TaxB2PComponent.prototype.search = function () {
        // check number of days > 60?
        if (moment(this.endDate).diff(moment(this.startDate), 'days') > 60) {
            this.error = 'ไม่สามารถเลือกระยะเวลาเกิน 60 วัน';
            return;
        }
        this.error = null;
        // separate page
        if (this.viewing == null) {
            this.currentPage = 1;
            this.sortBy = null;
            this.sortMode = null;
            if (this.tableData && this.tableData.length > 0) {
                this.table.reset();
            }
            this.loadData();
        }
        else {
            this.detailCurrentPage = 1;
            this.detailSortBy = null;
            this.detailSortMode = null;
            if (this.detailTableData && this.detailTableData.length > 0) {
                this.detailTable.reset();
            }
            this.loadDetailData();
        }
    };
    TaxB2PComponent.prototype.detailPageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.detailCurrentPage));
        this.loadDetailData(params);
    };
    TaxB2PComponent.prototype.detailSort = function (event) {
        this.detailSortBy = event.field;
        if (event.order === 1) {
            this.detailSortMode = 'asc';
        }
        else {
            this.detailSortMode = 'desc';
        }
    };
    TaxB2PComponent.prototype.loadDetailData = function (params) {
        var _this = this;
        this.loading = true;
        var data = __assign({}, this.viewing, { doc_type: this.selectedDetailDocumentType, status: this.selectedDetailStatus, items_per_page: this.detailItemsPerPage });
        // apply sort if any
        if (this.detailSortBy != null && this.detailSortMode != null) {
            data['sort'] = this.detailSortBy;
            data['sort_type'] = this.detailSortMode;
        }
        // remove page number if current page is 1
        if (this.detailCurrentPage === 1) {
            params = null;
        }
        this.apiService.postB2PDocumentSummaryDetail(data, params).subscribe(function (result) {
            _this.detailTotalItems = result.count;
            _this.detailTableData = result.results;
            _this.loading = false;
        }, function (error) {
            _this.error = 'เกิดข้อผิดพลาด';
            _this.loading = false;
        });
    };
    TaxB2PComponent.prototype.clear = function () {
        // separate page
        if (this.viewing == null) {
            this.selectedCompany = null;
            this.selectedBuyer = null;
            // set default date range
            this.startDate = new Date();
            this.startDate.setDate(this.startDate.getDate() - 60);
            this.endDate = new Date();
            this.selectedDocumentType = null;
            this.selectedStatus = null;
        }
        else {
            this.selectedDetailDocumentType = null;
            this.selectedDetailStatus = null;
        }
        // reload data
        this.search();
    };
    TaxB2PComponent.prototype.pageChanged = function () {
        var params = new HttpParams().set('page', _.toString(this.currentPage));
        this.loadData(params);
    };
    TaxB2PComponent.prototype.sort = function (event) {
        this.sortBy = event.field;
        if (event.order === 1) {
            this.sortMode = 'asc';
        }
        else {
            this.sortMode = 'desc';
        }
    };
    TaxB2PComponent.prototype.downloadExcel = function (index) {
        var _this = this;
        this.tableData[index].loadingExcel = true;
        var data = __assign({}, this.tableData[index], { doc_type: this.selectedDocumentType, status: this.selectedStatus });
        this.apiService.downloadB2PDocumentSummaryDetailExcel(data).subscribe(function (obj) {
            var file_name = 'documents' + moment().format('YYYY-MM-DD') + '.xlsx';
            _this.apiService.createDownloadFile(obj, file_name);
            _this.tableData[index].loadingExcel = false;
        }, function (error) {
        });
    };
    TaxB2PComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
        if (this.endDate < this.minDate) {
            this.endDate = this.minDate;
        }
    };
    TaxB2PComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
        if (this.startDate > this.maxDate) {
            this.startDate = this.maxDate;
        }
    };
    TaxB2PComponent.prototype.viewDetail = function (event) {
        // this.detailItemsPerPage = 40;
        // this.detailCurrentPage = 1;
        // this.detailSortBy = null;
        // this.detailSortMode = null;
        // this.detailTableData = [];
        // this.detailTotalItems = undefined;
        this.selectedDetailDocumentType = this.selectedDocumentType;
        this.selectedDetailStatus = this.selectedStatus;
        this.loadDetailData();
    };
    TaxB2PComponent.prototype.viewSummary = function () {
        // this.detailItemsPerPage = 40;
        this.detailCurrentPage = 1;
        this.detailSortBy = null;
        this.detailSortMode = null;
        this.detailTableData = [];
        this.detailTotalItems = undefined;
        // this.selectedDetailDocumentType = null;
        // this.selectedDetailStatus = null;
        this.viewing = null;
    };
    return TaxB2PComponent;
}());
export { TaxB2PComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-b2p/tax-b2p.component.ts.pre-build-optimizer.js